import * as React from 'react';
import { st, classes } from './ErrorMessageWrapper.st.css';
import { ErrorMessageWrapperProps } from './types';

export const ErrorMessageWrapper: React.FunctionComponent<
  ErrorMessageWrapperProps
> = (props) => {
  const { render, error, disabled, errorMessage, className } = props;

  const inErrorState = error && !disabled && !!errorMessage;

  return (
    <div className={st(classes.root, className)} data-hook={props['data-hook']}>
      {render({ error: inErrorState })}
      {inErrorState && (
        <div className={classes.errorMessage}>{errorMessage}</div>
      )}
    </div>
  );
};
